import { digitsOnlyBeforeInput } from '@/helpers/inputHelpers';
import { PalmettoIcon, PalmettoSelect, PalmettoTextInput } from '@palmetto/dsm-components';

const BANK_ACCOUNT_ICON = <PalmettoIcon name="moneyBankAccount" size="sm" />;

interface BankAccountTypeItem {
  label: string;
  value: string;
  selected: boolean;
}

interface CustomerDirectPaymentAchFormProps {
  accountHolderName: string;
  onAccountHolderNameChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accountHolderNameError: string | null;
  routingNumber: string;
  onRoutingNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  routingError: string | null;
  accountNumber: string;
  onAccountNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  accountNumberError: string | null;
  confirmAccountNumber: string;
  onConfirmAccountNumberChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  confirmAccountNumberError: string | null;
  bankAccountTypeValue: string[];
  onBankAccountTypeChange: (details: { value: string[] }) => void;
  bankAccountTypeItems: BankAccountTypeItem[];
}

export function CustomerDirectPaymentAchForm({
  accountHolderName,
  onAccountHolderNameChange,
  accountHolderNameError,
  routingNumber,
  onRoutingNumberChange,
  routingError,
  accountNumber,
  onAccountNumberChange,
  accountNumberError,
  confirmAccountNumber,
  onConfirmAccountNumberChange,
  confirmAccountNumberError,
  bankAccountTypeValue,
  onBankAccountTypeChange,
  bankAccountTypeItems,
}: CustomerDirectPaymentAchFormProps) {
  return (
    <div className="flex flex-col gap-10">
      <div className="dp-inputs flex flex-col gap-10">
        <PalmettoTextInput
          label="Account holder name"
          value={accountHolderName}
          onChange={onAccountHolderNameChange}
          placeholder="Account holder name"
          validationMessage={accountHolderNameError ? { type: 'error', text: accountHolderNameError } : undefined}
        />
        <PalmettoTextInput
          label="Routing number"
          value={routingNumber}
          onChange={onRoutingNumberChange}
          onBeforeInput={digitsOnlyBeforeInput}
          placeholder="Routing number"
          maxLength={9}
          inputMode="numeric"
          validationMessage={routingError ? { type: 'error', text: routingError } : undefined}
        />
        <PalmettoTextInput
          label="Account number"
          value={accountNumber}
          onChange={onAccountNumberChange}
          onBeforeInput={digitsOnlyBeforeInput}
          placeholder="Account number"
          maxLength={17}
          inputMode="numeric"
          leadingIcon={BANK_ACCOUNT_ICON}
          validationMessage={accountNumberError ? { type: 'error', text: accountNumberError } : undefined}
        />
        <PalmettoTextInput
          label="Confirm account number"
          value={confirmAccountNumber}
          onChange={onConfirmAccountNumberChange}
          onBeforeInput={digitsOnlyBeforeInput}
          placeholder="Confirm account number"
          maxLength={17}
          inputMode="numeric"
          leadingIcon={BANK_ACCOUNT_ICON}
          validationMessage={
            confirmAccountNumberError ? { type: 'error', text: confirmAccountNumberError } : undefined
          }
        />
      </div>
      <PalmettoSelect
        label="Account type"
        value={bankAccountTypeValue}
        onValueChange={onBankAccountTypeChange}
        items={bankAccountTypeItems}
      />
    </div>
  );
}
